import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import { bindActionCreators } from 'redux';

import { routes, modals } from './routes';


const Routes = (route) => {
	if (route.notlogged) {
		if (route.user.logged) {
			return (
				<Route
					path={route.path}
					render={(props) => (
						<Redirect
							to={{
								pathname: '/dashboard',
								state: { from: props.location }
							}}
						/>
					)}
				/>
			)
		}
	}

	if (route.roles) {
		return (
			<Route
				path={route.path}
				render={(props) => (
					route.user.logged && route.roles.find(el => el === route.user.Role)
						? (
							<route.component {...props} routes={route.routes} />
						)
						: (
							<Redirect
								to={{
									pathname: '/login',
									state: { from: props.location }
								}}
							/>
						)
				)}
			/>
		)
	}

	return (
		<Route
			path={route.path}
			exact={route.exact}
			render={props => (
				<route.component {...props} routes={route.routes} />
			)}
		/>
	);
}



const Router = ({ user }) => (
	<Route
		render={() => (
			<>
				<Switch>
					{routes.map((route, i) => (<Routes user={user} key={i} {...route} />))}
				</Switch>
				{modals.map((route, i) => (<Routes user={user} key={i} {...route} />))}
			</>
		)}
	/>
)

function mapStateToProps(state) {
	return {
		user: state.user
	}
}
function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Router))